type JQueryDialog = {
  html: (_markup: string) => {
    dialog: (_options: Record<string, unknown>) => void
  }
  dialog: (_command: string) => void
  bind: (_event: string, _handler: () => void) => void
  length: number
}

type JQueryFactory = {
  (_selector: string): JQueryDialog
}

/**
 * Iframe-диалог правки профиля врача для staff — тот же, что lpu-staff.js.
 */
export default function openStaffDoctorEditDialog(url: string, tab: string) {
  if (!process.env.IS_CLIENT || !url || !tab) {
    return
  }

  const win = window as unknown as {
    jQuery?: JQueryFactory
    $?: JQueryFactory
  }
  const jquery = win.jQuery || win.$

  if (!jquery) {
    return
  }

  const dialog = jquery('#dialog')

  if (!dialog.length) {
    return
  }

  dialog.html(
    `<iframe src="${url}?tab=${tab}" height="520" width="750" style="border-width:0" id="edit_education"></iframe>`,
  ).dialog({
    modal: true,
    title: 'Добавить сведения',
    width: 800,
    resizable: false,
    open() {
      jquery('.ui-widget-overlay').bind('click', () => {
        jquery('#dialog').dialog('close')
      })
    },
  })
}
